var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgError = function SvgError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 19.556c-4.178 0-7.556-3.378-7.556-7.556S7.822 4.444 12 4.444 19.556 7.822 19.556 12 16.178 19.556 12 19.556zm0 0c4.178 0 7.556-3.378 7.556-7.556S16.178 4.444 12 4.444 4.444 7.822 4.444 12 7.822 19.556 12 19.556zm0-12v6.222m0 1.778v.888",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#F64D43"
  })));
};
export default SvgError;